import { Grid, Typography } from '@material-ui/core';
import React from 'react';
import InputWithFormik from '../../../components/inputs/InputWithFormik';

const ExportadorForm = props => {
  const { gridProps, edit = false } = props;

  const readOnly = {
    variant: 'filled',
    InputProps: {
      disableUnderline: true,
      inputProps: { readOnly: true }
    }
  };

  let readOnlyProps = {};
  if (!edit) {
    readOnlyProps = {
      variant: 'filled',
      InputProps: {
        disableUnderline: true,
        inputProps: { readOnly: true }
      }
    };
  }

  return (
    <>
      <Grid container item>
        <Typography variant="subtitle2" color="textSecondary" gutterBottom>
          Datos del Exportador
        </Typography>
      </Grid>

      <Grid container {...gridProps}>
        <Grid item xs={12} md={3}>
          <InputWithFormik
            label="RUC"
            name="rucExportador"
            uppercase
            {...readOnly}
          />
        </Grid>
        <Grid item xs={12} md={9}>
          <InputWithFormik
            label="Razón Social"
            name="razonSocialExportador"
            uppercase
            {...readOnly}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <InputWithFormik
            label="Ciudad"
            name="ciudadExportador"
            {...readOnlyProps}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <InputWithFormik
            label="Dirección"
            name="direccionExpo"
            {...readOnlyProps}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <InputWithFormik
            label="Código Postal"
            name="codigoPostal"
            {...readOnlyProps}
          />
        </Grid>
      </Grid>

      <Grid container item>
        <Typography variant="subtitle2" color="textSecondary" gutterBottom>
          Datos del Representante Legal
        </Typography>
      </Grid>

      <Grid container {...gridProps}>
        <Grid item xs={12} md={6}>
          <InputWithFormik
            label="Nombre del Contacto"
            name="personaContacto"
            {...readOnlyProps}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <InputWithFormik
            label="Teléfono / Fax"
            name="telefono"
            {...readOnlyProps}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <InputWithFormik
            label="Correo electrónico"
            name="emailExpo"
            lowercase
            {...readOnlyProps}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default ExportadorForm;
